import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "pages.privateArea" */ /* webpackPrefetch: true */
      './PrivateArea.component'
    ),
);
